module.exports = __webpack_public_path__ + "static/media/woman_03.8a454fc4.png";